<template>

    <div class="container">
      <header-com />
      <header class="header">
        <div class="center">
          <i class="back"></i>
          <div class="status">
            <img :src="showIcon(detail.stateText)" align="middle" class="title_icon">
            <span class="f32 status-text"><span>{{detail.stateText}}</span></span>
          </div>
        </div>
      </header>
      <div class="abs-address">
        <address-com :model='detail'/>
      </div>
      <div class="goods-info" :class='{marginTop:!detail.contacts}'>
        <order-module-title title="商品信息" v-if='detail.bookingsCuringServiceBoList && detail.bookingsCuringServiceBoList.length != 0'/>
        <ul v-if='detail.bookingsCuringServiceBoList && detail.bookingsCuringServiceBoList.length != 0'>
          <li v-for='(item,index) in detail.bookingsCuringServiceBoList'><booking-order-com :model='item'/></li>
        </ul>
      </div>
      <div class="connect-kf f13" @click='contect'>
        <i></i>
        <span>联系客服</span>
      </div>
      <div class="block"></div>
      <div class="order-info" v-if='detail.pickingWay != 0'>
        <order-module-title title="邮递信息"/>
        <ul>
          <li class="f28">邮寄方式：{{detail.pickingWayText}}</li>
          <!-- <li class="f28" v-if='detail.pickingWay == 20 || detail.pickingWay == 40'>上门日期：{{detail.pickingDate.split(' ')[0]}}</li> -->
          <li class="f28" v-if='detail.pickingWay == 40'>预约时间：{{detail.pickingDate.split(' ')[0]}} {{detail.pickingStartTime}}~{{detail.pickingEndTime}}</li>
          <!-- 待定 -->
          <!-- <li class="f28" v-if='detail.paymentState == 20'>支付方式：{{detail.paymentWay}}</li> -->
          <li class="f28 warehouse" v-if='detail.warehouse'>
            <span>包拯地址：{{detail.warehouse.contacts}} {{detail.warehouse.mobile}} {{detail.warehouse.address}}</span>
            <button class="copy-btn copy" v-copy="detail.warehouse.contacts + detail.warehouse.mobile + detail.warehouse.address" v-if='detail.warehouse.contacts'>复制</button>
          </li>

          <li class='border' v-if='detail.pickingWay == 40 && detail.bookingsOrderPackageBo'></li>
         
          <li class="f28" v-if='detail.pickingWay == 40 && detail.bookingsOrderPackageBo'>取件时间：{{detail.bookingsOrderPackageBo.expressPickedTime}}</li>
          
          
          <li class="f28" v-if='detail.pickingWay != 20 && detail.pickingWay != 30 && detail.bookingsOrderPackageBo'>快递平台：{{detail.bookingsOrderPackageBo.expressPlatformName}}</li>
          <li class="f28" v-if='detail.pickingWay != 20 && detail.pickingWay != 30 && detail.bookingsOrderPackageBo'>快递单号：<span>{{detail.bookingsOrderPackageBo.expressCodeList.join('/')}}</span>

          </li>
          
       
        </ul>
      </div>
      <div class="block"></div>
      <div class="order-info">
        <order-module-title title="订单信息"/>
        <ul>
          <li class="f28">预约单号：{{detail.code}}</li>
          <li class="f28">物品数量：{{detail.goodsNumber}}件</li>
          <li class="f28" >下单时间：{{detail.createTime}}</li>
          <li class="f28" v-if='detail.paymentWay'>支付方式：{{detail.paymentWay}}</li>
        </ul>
      </div>
      <div class="remark f28" v-if='remarkShow'><div>备注：{{detail.remark}}</div></div>
      <div class="block"></div>
      <div class="price-info">
        <ul v-if='detail.paymentState != 30'>
          <li class="f32">
            <span>订单金额</span>
            <span>¥{{detail.orderAmount}}</span>
          </li>
          <li class="f32" v-if='detail.promotionAmount'>   
            <span>促销优惠</span>
            <span>¥{{detail.promotionAmount}}</span>
          </li>
          <li class="f32" v-if='detail.useSurplusAmount'>   
            <span>余额抵扣</span>
            <span>¥{{detail.useSurplusAmount}}</span>
          </li>
          <li class="f32" v-if='detail.discountAmount'>   
            <span>优惠金额</span>
            <span>¥{{detail.discountAmount}}</span>
          </li>
          
        </ul>
        <div class="f28" v-if='detail.paymentState == 20'>
          <span>实付金额：<span class="f44">¥{{detail.realAmount}}</span></span>
          <span class='left_span'>共计{{detail.goodsNumber}}件商品</span>
        </div>
      </div>
      <div class="g-fixed-bottom shadow" v-if='type==1&&isOwner' v-show='detail.paymentState == 10|| detail.state == 10 || detail.state == 100 || concelButton(detail.state) || detail.state == 120 || detail.state == 119 || detail.state == 129 || detail.state == 220'>
            <button class="primary"  v-if='detail.state == 10'  @click='sureMakeFn'>确认预约</button>
            <button class="primary" v-if='detail.paymentState == 10 && detail.state != 900' @click='$router.push({name:"pay",query:{id:detail.code}})'>立即支付</button>
            <button class="primary" v-if='detail.state == 100 && (detail.paymentState == 20 || detail.paymentState == 30) && !detail.existBookingsOrderPackage' @click='$router.push({name:"fillExpress",query:{id:detail.id}})'>填写快递单号</button>
            <button class="secondary" v-if='showCancelBtn(detail)' @click='concelShow = true'>取消预约</button>
            <button class="secondary" @click='lookExpress(detail)' v-if='detail.state == 220'>查看物流</button>
            <button class="secondary" v-if="(detail.state == 119 || detail.state == 129)&&detail.state!=10" @click='makeAgain(detail)'>立即寄出</button>
            <!-- <button class="secondary" v-if='detail.state == 60'>退款进度</button> -->
      </div>
  
      <!-- 取消订单弹窗 -->
      <van-popup position="bottom" v-model="concelShow">
        <div class="containers f28">
          <div class="title">请选择取消订单的原因（必选）</div>
          <div class="close" @click="concelShow = false"></div>
          <ul>
            <li v-for='(item,index) in concelList' :key='index' @click='concelReason = item.key'>
              <div><radio @changeRadio='concelReason = item.key' :checked="concelReason == item.key"/></div>
              <span>{{item.value}}</span>
            </li>
          </ul>
          <button class="submit btn-black-round" :disabled='!concelReason' @click='concelShowAction'>提交</button>
        </div>
      </van-popup>
  

      <transition name="van-fade">
        <div class='markShdow' @click='showKefu = false' v-if='showKefu'>
          <div>
            <img src="/images/base/weChart.png" align="middle">
            <div  class="qrcode-wrap">

              <img :src="dataUrl" alt="" />
            </div>
          </div>
        </div>
      </transition>


      <van-popup position="bottom" v-model="expressShow">
        <div class='containerRefond f28 content'>
          <div class="title">物流信息</div>
          <div class="close" @click="expressShow = false"></div>
          <ul>
            <li class='arrive'>
              
              <span class='round'>
                收
              </span>
              <div class='text'>
                <div class='item_title'>包拯地址：包拯工作室 17526857604</div>
                <div class='dero'>天津市武清区开发区武清逸仙园小区翠柳道6号（包拯修复中心）</div>
              </div>
      
            </li>
            <li v-for='(item,index) in expressLog' class='refundLi' :class='{active : !index }'>
              <div class='time'>
                <div>
                  {{item.acceptDate}}
                </div>
                <div>
                  {{item.acceptTime}}
                </div>
              </div>
              <span class='round'>
                <span></span>
              </span>
              <div class='text'>
                <div class='item_title'>{{item.remark}}</div>
                <div class='dero'>{{item.acceptAddress}}</div>
              </div>
      
            </li>
          </ul>
        </div>
      </van-popup>

      <div v-if='againShow && shadowShow' class='shadows'></div>
      <van-popup position="bottom" v-model="againShow">
        <div class='containerRefond f28 contenter'>
          <div class="title">邮递方式</div>
          <div class="close" @click="againShow = false"></div>
          <select-address v-if='againShow' @showShade='shadowShow = true'  @hiddenShade='shadowShow = false' class='address' @changeType='changeType' :sendFrom='sendFrom' @changeAdr='changeAdr' @changeDate='changeDate'></select-address>
          <button class="primary again" @click='againSubmit()'>立即寄出</button>
        </div>
      </van-popup>

      <!-- 确认预约弹窗 -->
      <div v-if='sureMakePopup && sureMakeShow' class='shadows'></div>
      <van-popup position="bottom" v-model="sureMakePopup">
        <div class='containerRefond f28 contenter'>
          <div class="close" @click="sureMakePopup = false"></div>
          <select-address2 v-if='sureMakePopup' @showShade='sureMakeShow = true' :timeBox='timeBox' @hiddenShade='sureMakeShow = false' class='address' @changeAdr='changeAdr2' :defultAdrId='detail.customerAddressBo.id' @changeDate='changeDate2'></select-address2>
          <button class="primary again" @click="submitMakeBtn">确认预约</button>
        </div>
      </van-popup>
      <!-- 确认预约弹窗 -->

    </div>
</template>

<script>
  import orderApi from '@/axios/order'
  import { Popup } from 'vant'
  import { Toast } from 'vant';
  import wxShare from "@/assets/js/wx.share"

  import publicObj from '@/assets/js/public';
  import QRCode from 'qrcode';
  export default {
    name: 'orderDetail',
    components : {

    },
    data () {
      return {
        sureMakePopup: false,
        sureMakeShow: false,
        newParams: {},
        
        shadowShow : false,
        sendFrom : {
          sendType : 40,
          customerAddressId : '',
          pickingDate : '',
          pickingTime : '',
        },
        againShow : false,
        concelReason : '',
        concelList : [
        ],
        concelShow : false,
        showKefu : false,
        bookingId : '',
        detail : {
          warehouse : {
            contacts : ''
          },
          bookingsOrderPackageBo : {
            expressCodeList : []
          }
        },
        type : this.$route.query.type ? this.$route.query.type : 1,
        dataUrl : '',
        expressLog : [],
        expressShow : false,
        encryptCustomerId: '',
        isOwner: false,
        timeBox: false,
        union_id: localStorage.getItem('unionId')
      }
    },
    computed: {
      customerId() {
        return this.$store.state.customerId;
      },
      setServicePhone() {
          return this.$store.state.servicePhone
      },
      remarkShow(){
          if(!this.detail.remark){
            return false;
          }
          let reg = /^90\d+$/
            
          if(!reg.test(this.detail.code)){
            return true;
          }else{
            return false;
          }

      }
    },
    created () {
      this.bookingId = this.$route.query.id;
      // if(this.$route.query.customerId) {
      //   this.encryptCustomerId = this.$route.query.customerId
      //   //获取服务详细信息
      //   this.getOtherDetail();
      //   this.getReasonList();
      //   return
      // }
      
      //获取服务详细信息
      this.getDetail(this.bookingId);
      this.getReasonList();
    },
    mounted () {
      if(this.$route.query.customerName) {
        let name = decodeURIComponent(this.$route.query.customerName)
        let shareBody = {
                desc : '快来确认预约吧',
                title : '【包拯】'+name+'快来确认你的预约方案吧',
                imgUrl : 'https://img.chenzhen.shop/2022/01/06/c272022d-7e89-4c80-83e7-c1f38ae3d8a7.jpg',
                link : window.location.href
              };
              setTimeout(()=>{
                wxShare(shareBody)
              },1000)
        }
        
        QRCode.toDataURL(publicObj.byCustomerIdCreateQRcode(this.setServicePhone))
          .then(res=>{
              this.dataUrl = res
          })
    },
    methods: {
      sureMakeFn() {
        let detailTime = ''
        this.timeBox = false
        if(this.detail.pickingStartTime) {
          detailTime = this.detail.pickingDate + ' ' + this.detail.pickingStartTime
        } else {
          detailTime = this.detail.pickingDate + ' 23:59'
        }

        if(this.detail.pickingWay==40) {

          if(new Date().getTime()>new Date(detailTime).getTime()) {
            this.timeBox = true
          }
          this.sureMakePopup = true;

        }else if(this.detail.pickingWay==20||this.detail.pickingWay==50) {

          if(new Date().getTime()>new Date(detailTime).getTime()) {
            // 提示找客服改时间
            Toast('包拯上门取件时间已经失效，请您重新联系包拯客服确认时间')
            return
          }
          this.sureMakePopup = true;

        } else {
          this.submitMake()
        }
      },

      submitMake() {
        let params = {
          customerId: this.customerId,
          bookingsId: this.bookingId,
          bookingsOrderCode: this.detail.code,
          pickingWay: this.detail.pickingWay,
          union_id: this.union_id
        }
        
        orderApi.sureMakeSubmit(params).then((res)=>{
          this.getDetail(this.bookingId);
          this.getReasonList();
        })
      },

      submitMakeBtn() {
        if(this.timeBox&&!this.newParams.pickingTime) {
          Toast('请选择上门取件时间')
          return
        }
        let params = {
          customerId: this.customerId,
          bookingsId: this.bookingId,
          bookingsOrderCode: this.detail.code,
          pickingWay: this.detail.pickingWay,
          union_id: this.union_id
        }
        if(this.newParams.pickingDate) {
          params.pickingDate = this.newParams.pickingDate
        } else {
          params.pickingDate = this.detail.pickingDate
        }

        if(this.newParams.pickingTime) {
          params.pickingTime = this.newParams.pickingTime
        } else {
          params.pickingTime = this.detail.pickingTime
        }

        if(this.newParams.customerAddressId) {
          params.customerAddressId = this.newParams.customerAddressId
        } else {
          params.customerAddressId = this.userAddressId
        }
        orderApi.sureMakeSubmit(params).then((res)=>{
          this.timeBox = false
          this.sureMakePopup = false;
          this.getDetail(this.bookingId);
          this.getReasonList();
        })
      },

      isActive(item){
        if(item.bookingsCuringServiceBoList){
          if(item.bookingsCuringServiceBoList[0]){
            if(item.bookingsCuringServiceBoList[0].classify == 20){
              return true;
            }else{
              return false;
            }
          }else{
            return false;
          }
        }else{
          return false;
        }
      },
      showCancelBtn(item){
        //是否是囤货卷
        //是否是拼团
        //普通预约单
        if(this.isActive(item)){
          //囤货卷支付状态必须是10
          if(item.paymentState == 10){
            return true
          }else{
            return false
          }
        }else if(item.groupRecordStatus){
          //拼团
          // if(item.groupRecordStatus != 30){
          //   return true;
          // }else{
            return false;
          // }
        }else{
          //普通预约单
          if(this.concelButton(item.state) && !item.existBookingsOrderPackage){
            return true;
          }else{
            if(item.state == 120 || item.state == 119 || item.state == 129  || item.state == 0){
              return true;
            }else{
              return false;
            }
          }
        }
      },
      changeDate(data,time){
        this.sendFrom.pickingDate = data;
        this.sendFrom.pickingTime = time;
      },
      changeDate2(data,time){
        this.newParams.pickingDate = data;
        this.newParams.pickingTime = time;
      },
      changeAdr(element){
        this.sendFrom.customerAddressId = element.id;
      },
      changeAdr2(element){
        this.newParams.customerAddressId = element.id;
      },
      changeType(index){
        this.sendFrom.sendType = index;
      }, 
      againSubmit(){
        let params = {
          
        }
        params.pickingWay = this.sendFrom.sendType;
        params.bookingsOrderCode = this.againId;
        if(params.pickingWay == 40){
          params.pickingDate = this.sendFrom.pickingDate;
          params.pickingTime = this.sendFrom.pickingTime;
          params.customerAddressId = this.sendFrom.customerAddressId;
          
          //参数验证
          if(!params.customerAddressId){
              Toast('请选择地址');
              
              return;
          }

          if(!params.pickingDate){
              Toast('请选择上门时间');
            
              return;
          }
        }
        

        orderApi.sendNow(params).then((res)=>{
          this.againShow = false;

          this.getDetail(this.bookingId);
        })
      },

      sureMake() {
        
      },

      makeAgain(item){
        this.sendFrom = {
          sendType : 40,
          customerAddressId : '',
          pickingDate : '',
          pickingTime : '',
        }
        this.againId = item.code;
        this.againShow = true;
      },  
      lookExpress(item){
        //code暂时写死
        orderApi.listRouteInfo(item.code).then((res)=>{
          this.expressShow = true;
          this.expressLog = res;
        })
      },
      showIcon(text){
        switch(text){
          case '待付款' : return '/images/order/daifukuan.png';
          case '邮递中' : return '/images/order/youdizhong.png';
          case '已送达' : return '/images/order/yisongda.png';
          case '待取件' : return '/images/order/daiqujian.png';
          case '已取件' : return '/images/order/yiqujian.png';
          case '待发货' : return '/images/order/daifahuo.png';
        }
        return '/images/order/daifukuan.png';
      },
      concelShowAction(){
        let params = {
          id : this.bookingId,
          cancelReasonId : this.concelReason
        }

        orderApi.cancelBookingsOrder(params).then((res)=>{
          this.concelShow = false;
          Toast('取消成功');
          this.getDetail(this.bookingId);
        })
      },
      //获得取消原因
      getReasonList(){
        orderApi.getCancelReason({}).then((res)=>{
          this.concelList = res;
        })
      },
      //联系客服按钮     
      contect(){
          this.showKefu = true;
      },
      //是否显示已取消按钮
      concelButton(type){
        if(type == 100 || type == 110 || type == 120){
          return true;
        }else{
          return false;
        }
      },
      getDetail(id){
        orderApi.getBookingsById(id).then((res)=>{
          this.detail = res;
          if(this.customerId == res.customerId) {
            this.isOwner = true
          }
        })
      },

      getOtherDetail(id){
        let params = {
          bookingsId: this.bookingId,
          encryptCustomerId: this.encryptCustomerId
        }
        orderApi.getOtherBookingsById(params).then((res)=>{
          this.detail = res;
          if(this.customerId == res.customerId) {
            this.isOwner = true
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .active{
    color:#7ADFDF!important;
    span{
      color:#7ADFDF!important;
      
    }
    div{
       color:#7ADFDF!important;
    }
    .round{
      border: 1px solid #7ADFDF!important;
      span{
        background: #7ADFDF!important;
      }
    }
  }
  .again{
    margin-bottom: 30px;
    margin-right: 30px;
    margin-top:50px;
    float: right;
  }
  .shadows{
    background-color: rgba(0,0,0,.7);;
    position: fixed;
    width: 100%;
    top:0;
    bottom: 0;
    left: 0;

  }
  .border{
    border-top:1px dashed #E9E9E9;
    width: 100%;
    margin-top: 30px;
    margin-bottom: 30px!important;
    max-width: 100%!important;
  }
  .warehouse{
    
    span{
      // line-height: 50px;
    }
  }
  .marginTop{
    margin-top: 20px!important;
  }
  .left_span{
    position: relative;
    top:1px;
  }
  .title_icon{
    width: 40px;
    margin-right: 20px;
    position: relative;
    top:3px;
  }
  .markShdow{
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;
    text-align: center;
    background: rgba(0,0,0,.8);
    width: 100%;
    height: 100%;
    z-index: 99;
  }
  .markShdow div {
      width: 100%;
      position: relative;
      margin-top:200px;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-direction: column-reverse;
      flex-direction: column-reverse;
  }
  .markShdow div>img{
      width: 100%;
  }
  .markShdow div .qrcode-wrap {
      position: absolute;
      bottom: 15px;
      width: 280px;
      height: 280px;
      background: red;
      left: 50%;
      margin-left:-140px;
  }
  .container{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 108px;
    .header{
      width: 100%;
      height: 200px;
      background: url('/images/order/order-header-bg.png') no-repeat center;
      .center{
        padding: 30px 30px 0 30px;
        display: flex;
        justify-content: space-between;
        .back{
          width: 60px;
          height: 60px;
          // background: url('/images/public/back.png') no-repeat center;
          background-size: 60px;
        }
        .status{
          width: 170px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          text-align: right;
          .status-text{
            color: #fff;
            text-align: right;
          }
        }
      }
    }
    .abs-address{
      position: absolute;
      top: 124px;
    }
    .goods-info{
      margin-top: 166px;
      ul{
        margin: 30px 0;
        li{
          margin-bottom: 20px;
          padding-left: 20px;
          &:last-child{
            margin: 0;
          }
        }
      }
    }
    .connect-kf{
      width: 100%;
      height: 94px;
      border-top: 2px solid #EEEEEE;
      display: flex;
      align-items: center;
      justify-content: center;
      i{
        width: 32px;
        height: 32px;
        margin-right: 20px;
        background: url("/images/order/kefu-avar.png") no-repeat center;
        background-size: 32px;
      }
    }
    .order-info{
      padding: 30px 0;
      color: #666666;
      ul{
        padding-left: 18px;
        margin-top: 34px;
        li{
          line-height: 40px;
          margin-bottom: 10px;
          max-width: 512px;
          position: relative;
          .copy{
            right: -152px;
            position: absolute;
          }
        }
      }
    }
    .remark{
      border-top: 2px solid #EEEEEE;
      width: 100%;
      padding: 30px 0;
      div{
        padding: 0 50px;
        line-height: 40px;
      }
    }
    .price-info{
      width: 100%;
      ul{
        padding: 30px;
        border-bottom: 2px solid #eee;
        li{
          display: flex;
          justify-content: space-between;
          line-height: 44px;
          margin-bottom: 20px;
          &:last-child{
            margin: 0;
          }
        }
      }
      div{
        padding: 0 30px;
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        height: 142px;
        line-height: 142px;
        font-weight: 500;
        span{
          margin-left: 20px;
          &:last-child{
            margin-left: 0px;
          }
        }
      }
    }
    .shadow{
      box-shadow:0px -2px 20px 0px rgba(0,0,0,0.06);
      height: 108px;
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      padding-top: 0;
      button{
        margin-right: 20px;
        &:first-child{
            margin-right: 0px;
        }
      }
    }
  }
  .van-popup--bottom{
    width: 101%;
  }
  .containers{
    height: 740px;
    padding: 30px;
    position: relative;
    .title{
      line-height: 40px;
      margin-bottom: 50px;
    }
    ul li{
      width: 100%;
      height: 40px;
      
      margin-bottom: 60px;
      display: flex;
      align-items: center;
      span{
        margin-top:2px; 
      }
      &>div{
        margin-right: 20px;
      }
    }
    .submit{
      position: absolute;
      bottom: 30px;
      right: 30px;
    }
    .close{
      width: 36px;
      height: 36px;
      position: absolute;
      top: 30px;
      right: 30px;
      background: url("/images/public/close.png") no-repeat center;
      background-size: 32px;
    }
  }

  .contenter{
    padding-left:0!important;
    padding-right:0!important;

    .title{
      padding-top:30px;
      margin-left: 40px;
      margin-bottom: 0!important;
    }
  }
  .arrive{
    border-left:1px dashed #7ADFDF!important;
    font-size: 12px!important;
    .item_title{
      margin-bottom: 10px!important;
      font-size:20px!important;
    }
    .round{
      background: #7ADFDF!important;
      border: none!important;
      color:#fff;
      font-size: 20px!important;
    }
  }
  .containerRefond{
      padding: 30px;
      position: relative;
      padding-bottom:90px; 
      // padding-left:100px;
      .title{
        line-height: 40px;
        margin-bottom: 50px;
        font-weight:500; 
      }
      .close{
        width: 36px;
        height: 36px;
        position: absolute;
        top: 30px;
        right: 30px;
        background: url("/images/public/close.png") no-repeat center;
        background-size: 32px;
      }
      ul{
        padding-left: 100px;
        padding-top: 10px;
        max-height: 600px;
        overflow: scroll;
        li{

          line-height: 40px;
          margin-top: 60px;

          padding-left:40px;
          position: relative;
          border-left:1px solid #E4E4E4;

          .text{
            position: relative;
            top:-52px;
            color:#999999;
            font-size: 24px;
            .item_title{
              margin-bottom: 30px;
              font-size:36px;

            }
          }
          .time{
            position: absolute;
            top:-55px;
            left: -95px;
            font-size: 14px;
            color:#999999;
            line-height: 22px;

          }
          .round{
            width: 36px;
            height: 36px;
            display: inline-block;

            // background: #D2D2D2;
            border: 1px solid #D2D2D2;
            border-radius:50%; 
            position: absolute;
            left:-19px;
            top:-50px;
            text-align: center;
            span{
              width: 28px;
              height: 28px;
              background: #D2D2D2;
              display: inline-block;
              margin-top:4px;
         
              border-radius:50%;  
            }
          }
          time{
            float: right;
          }
        }
      }
  }
</style>
